import styled from 'styled-components';
import tw from 'tailwind.macro';
import { math, rem } from 'polished';

import { theme } from '../../tailwind.config.js';

export const Button = styled.button`
  ${tw`bg-black font-bold font-text outline-none pb-12 px-24 pt-10 rounded text-base text-white`};
  line-height: ${math('22/17')};

  &:focus {
    ${tw`outline-none`};
  }
`;

export const ButtonOutline = styled.button`
  ${tw`font-bold font-text outline-none pb-12 px-24 pt-10 rounded text-base text-black`};
  border: 1px solid black;
  ${props => props.color === 'white' && tw`border-white text-white`}
  ${props =>
    (props.marginBottom === '0' && tw`mb-0`) ||
    (props.marginBottom === '6' && tw`mb-6`) ||
    (props.marginBottom === '8' && tw`mb-8`) ||
    (props.marginBottom === '12' && tw`mb-12`) ||
    (props.marginBottom === '14' && tw`mb-14`) ||
    (props.marginBottom === '16' && tw`mb-16`) ||
    (props.marginBottom === '24' && tw`mb-24`) ||
    (props.marginBottom === '32' && tw`mb-32`) ||
    (props.marginBottom === '42' && tw`mb-42`) ||
    (props.marginBottom === '48' && tw`mb-48`) ||
    (props.marginBottom === '46' && tw`mb-46`) ||
    (props.marginBottom === '64' && tw`mb-64`) ||
    (props.marginBottom === '144' && tw`mb-144`)}
  line-height: ${math('22/17')};

  &:focus {
    ${tw`outline-none`};
  }
`;
